export default "__VITE_ASSET__DOl6Q4hi__"